import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest, HttpInterceptor } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from './local-storage.service';
import { errorMessage } from './utils/errorMessagges.constant';
@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService, private storage: StorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError(error => {
        let errorMessagge = '';
        if (error.status == 401) {
          if (error.error != null) {
            if (error.error.code == 900) {
              this.toastr.error('User or password are incorrect', 'Error');
              return throwError(errorMessagge);
            }else if (error.error.code == 912) {
              this.toastr.error('The current password is not correct', 'Error');
              return throwError(errorMessagge);
            }else if(error.error.code == 901) {
              this.toastr.error('The username already exists', 'Error');
              return throwError(errorMessagge);
            }
          } else {
            this.storage.logout()
          }
        } 
        this.toastr.error(errorMessage(error.status), 'Error');

        return throwError(errorMessagge);
      })
    );
  }
}